var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { LanguageIcon } from "../../../../assets/svg/LanguageIcon";
import { LanguageIconENCN } from "../../../../assets/svg/LanguageIconENCN";
import { LANG } from "../types";
import { useLangSelector } from "./hooks";
var LanguageToggle = function (_a) {
    var className = _a.className;
    var _b = useLangSelector(), lang = _b.lang, handleLangToggle = _b.handleLangToggle;
    return (_jsx("div", __assign({ className: className }, { children: _jsx("div", __assign({ onClick: handleLangToggle }, { children: lang === LANG.EN ? _jsx(LanguageIcon, {}) : _jsx(LanguageIconENCN, {}) })) })));
};
export default LanguageToggle;
